// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ws0O","option":"styles_option__1vS5O","active":"styles_active__3Dwc7"};